import "./App.css";
import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./components/Home";

// ── Main pages ────────────────────────────────────────────────────────────────
const About    = React.lazy(() => import("./components/About"));
const Projects = React.lazy(() => import("./components/Projects"));
const Contact  = React.lazy(() => import("./components/Contactus"));

// ── Collection sub-pages ──────────────────────────────────────────────────────
const Pergolas    = React.lazy(() => import("./components/Products/Pergolas"));
const Partitions  = React.lazy(() => import("./components/Products/Partitions"));
const Doors       = React.lazy(() => import("./components/Products/Doors"));
const Sliders     = React.lazy(() => import("./components/Products/Sliders"));

function App() {
  // Remove the inline intro overlay (#vi) from index.html once React has painted.
  // We honour the animation duration: if React boots faster than 1.5s (fast connection)
  // we wait out the remainder; if slower (throttled mobile) we remove immediately.
  useEffect(() => {
    const el = document.getElementById('vi');
    if (!el) return; // already gone (return visit — vi-skip hid it, or already removed)

    const INTRO_MS = 1500; // total inline animation duration
    const elapsed  = performance.now(); // ms since navigation start
    const wait     = Math.max(0, INTRO_MS - elapsed);

    const fadeTimer = setTimeout(() => {
      el.style.transition = 'opacity 0.25s ease';
      el.style.opacity    = '0';

      const removeTimer = setTimeout(() => {
        el.remove();
        const css = document.getElementById('vi-css');
        if (css) css.remove();
      }, 300);

      return () => clearTimeout(removeTimer);
    }, wait);

    return () => clearTimeout(fadeTimer);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="App">
      <Navbar />
      <ScrollToTop>
        <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
          <Routes>
            <Route path="/"                          element={<Home />} />
            <Route path="/about"                     element={<About />} />
            <Route path="/collections"               element={<Navigate to="/" replace />} />
            <Route path="/collections/pergolas"      element={<Pergolas />} />
            <Route path="/collections/partitions"    element={<Partitions />} />
            <Route path="/collections/doors"         element={<Doors />} />
            <Route path="/collections/sliders"       element={<Sliders />} />
            <Route path="/projects"                  element={<Projects />} />
            <Route path="/contact"                   element={<Contact />} />

            {/* Legacy redirects */}
            <Route path="/products/pergolas"         element={<Pergolas />} />
            <Route path="/products/partitions"       element={<Partitions />} />
            <Route path="/products/doors"            element={<Doors />} />
            <Route path="/products/sliders"          element={<Sliders />} />
            <Route path="/gallery"                   element={<Projects />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
      <Footer />
    </div>
  );
}

export default App;
